<template>
    <headerLayout />
    <main class="md:bg-gray-50">
        <div class="xl:container px-3 xs:px-5 xl:px-3 pt-1 pb-0 md:pb-3">
            <slot />
        </div>
        <CountDown />
    </main>
    <FooterLayout />
</template>
<script>
import headerLayout from '@/components/layout/Header.vue';
import FooterLayout from '@/components/layout/Footer.vue';
import CountDown from '@/components/dialogs/PopupCountDown.vue';
import { inject, onMounted, watch, computed } from 'vue';
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router';
import routeName from '@/router/constant.js';
import dialogContnet from '@/json/dialogContent.js';
import { useStore } from 'vuex';
import aplCatlCode from '@/json/aplCatlCode';

export default {
    components: {
        headerLayout,
        FooterLayout,
        CountDown,
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const aplCatl = computed(() => store.state.permissions.aplCatl);

        onBeforeRouteUpdate((to, from, next) => {
            // 若在首頁
            if (route.name === routeName.HOME) {
                // 去了不能上一頁的頁面
                if (to.meta.unableBack) {
                    // 推一個首頁的history，避免點擊上一頁網址會變動
                    router.push({ name: routeName.HOME });
                } else if (to.name === routeName.HOME) {
                    // 在首頁點擊時history上一頁也是首頁，只有在上面被觸發時才會進入這裡
                } else {
                    // 前往meta.unableBack不等於true的畫面
                    next();
                }
            } else {
                // 不再首頁就不擋，都可以通行
                next();
            }
        });

        watch(() => route.name, (nV, oV) => {
            // 本頁unableBack為true
            if (route.meta.unableBack) {
                // 若meta.unableBack為 true，就先推一個此頁面的history
                history.pushState(history.state, null, document.URL);
            }
        }, { immediate: true });

        onMounted(() => {
            window.onpopstate = () => {
                // 本頁unableBack為true
                if (route.meta.unableBack) {
                    // 點擊上一頁時，就再推此頁面的history
                    history.pushState(history.state, null, document.URL);
                    modalShow();
                }
                // 本頁為首頁時
                // if (route.name === routeName.HOME) {
                //     // 點擊上一頁時，就再推此頁面的history
                //     history.pushState(history.state, null, '/otws/home');
                // }
            };
        });

        /* 打開離開燈箱 */
        const modalShow = () => {
            $vfm.show({
                component: 'DialogBase',
                params: aplCatl.value === aplCatlCode.E_NOTIFY_PROMO ? dialogContnet.leave : dialogContnet.leaveA3A4A5,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                        store.dispatch('permissions/goFubonOfficial');
                    },
                    cancel() {
                        $vfm.hide('DialogBase');
                    }
                }
            });
        };

        return {
            routeName
        };
    },
};
</script>
